var _ellipse, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 14.7 165 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.4984,
    cy: 97.1663,
    rx: 73.469,
    ry: 72.8533,
    fill: "url(#micButtonFill)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9948 28.5622C129.884 33.807 156.348 68.7741 151.103 106.664C145.858 144.553 110.891 171.017 73.0018 165.772C35.1124 160.527 8.64872 125.56 13.8935 87.6706C19.1382 49.7812 54.1054 23.3175 91.9948 28.5622Z",
    strokeWidth: 7.79838,
    stroke: "url(#micButtonStroke)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "micButtonFill",
    x1: 82.4984,
    y1: 31.9083,
    x2: 136.657,
    y2: 132.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400478,
    stopColor: "#D55E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "micButtonStroke",
    x1: 142.998,
    y1: 139.169,
    x2: 30.9983,
    y2: 49.1688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF5306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicButton);
export default __webpack_public_path__ + "static/media/MicButton.10c98f9faf000426efdfb6b5076f325b.svg";
export { ForwardRef as ReactComponent };